export const environment = {
  enableProdMode: true,
  environmentName: 'prod',
  TP_MENU: 0,
  VAPID_PUBLIC_KEY:
    'BEXalQEWacoe2-3n8IH2c4pYb4tcI__ShEUDSmSVXm3z6ezhP9RFBuaFxotxKPLmWbLnhDRG-cqzExfyE28w_RE',
  OAUTH_URL: 'https://oauth.api.nexuscloud.com.br/api',
  DNE_URL: 'https://dne.api.nexuscloud.com.br/api',
  API_URL_FRONTEND: 'https://app.nexuscloud.com.br',
  API_URL_CADASTRO: 'https://cadastro.api.nexuscloud.com.br/api',
  API_URL_COMPRAS: 'https://compras.api.nexuscloud.com.br/api',
  API_URL_ESTOQUE: 'https://estoque.api.nexuscloud.com.br/api',
  API_URL_FINANCEIRO: 'https://financeiro.api.nexuscloud.com.br/api',
  API_URL_VENDAS: 'https://vendas.api.nexuscloud.com.br/api',
  API_URL_PRECOS: 'https://precos.api.nexuscloud.com.br/api',
  API_URL_FISCAL: 'https://fiscal.api.nexuscloud.com.br/api',
  API_URL_COMISSOES: 'https://comissoes.api.nexuscloud.com.br/api',
  ASTUTUS_API_URL: 'https://astutus.api.nexuscloud.com.br/api',
  S3_API_URL: 'https://s3.api.nexuscloud.com.br/api',
  API_URL_REPORT: 'https://report.api.nexuscloud.com.br/api',
  API_URL_PRESTO: 'https://presto.api.nexuscloud.com.br/api',
  API_URL_SYNC: 'https://sync.api.nexuscloud.com.br/api',
  API_URL_MONITOR_NFE: 'https://monitor-nfe.api.nexuscloud.com.br/api',
  API_URL_DOMINIO: 'https://dominio.api.nexuscloud.com.br/api',
  API_URL_IO: 'https://io.api.nexuscloud.com.br/api',
  API_URL_QUEUE_MANAGER: 'https://queue-manager.api.nexuscloud.com.br/api',
  API_URL_ECOMMERCE: 'https://ecommerce.api.nexuscloud.com.br/api',
  API_URL_TASK_MANAGER: 'https://task-manager.api.nexuscloud.com.br/api',
  API_URL_NOTIFICATION: 'https://notification.api.nexuscloud.com.br/api',
  API_URL_EMAIL: 'https://email.api.nexuscloud.com.br/api',
  API_URL_AUDITORIA: 'https://auditoria.api.nexuscloud.com.br/api',
  INTEGRACAO_DOMINIO_URL: 'https://app.nexuscloud.com.br/#/integracao/dominio',
};
